import './LoaderSpinner.scss';
import Lottie from "lottie-react";
import loaderAnimation from "./LoaderAnimation.json";
// https://cssloaders.github.io/

const LoaderSpinner = () => {
  return (
    <div className="loader-container">
      {/* <div className="loader" /> */}
      <Lottie style={{ width:150 }} animationData={loaderAnimation} />
    </div>
  );
};
export default LoaderSpinner;
